import React, {Component} from 'react';
import GoogleMapReact from 'google-map-react';
import PropTypes from 'prop-types';

// container component.
class GoogleMap extends Component {
  render() {
    const {
      center, zoom, ...passThroughProps
    } = this.props;
    let options = () => ({
      'mapTypeControl': true,
      'fullscreenControl': false,
    });
    if (this.props.options) options = this.props.options;
    return (
      <GoogleMapReact
        bootstrapURLKeys={{
          client: 'gme-corelogicsolutions',
          channel: 'OTH_RISE',
          libraries: ['places'],
        }}
        defaultCenter={center}
        defaultZoom={zoom}
        options={options}
        {...passThroughProps}
      >
        {this.props.children}
      </GoogleMapReact>
    );
  }
}

GoogleMap.propTypes = {
  center: PropTypes.object.isRequired,
  zoom: PropTypes.number.isRequired,
};

export default GoogleMap;
